import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../common/Modal';

import { t } from '../../../../../../modules/infra/i18n';

const MaintainSKUChangesModal = ({
  handleModalClose,
  handleDisconnect,
  handleConnect,
  openedIsOn,
  vendorName,
  matchedItems,
  skuChanged,
}) => (
  <Modal
    className="shopify-modal shopify-connect-products-modal"
    display-if={openedIsOn}
    title={t('products:shopify.maintain_sku_modal.title')}
    close={handleModalClose}
    showCloseButton
  >
    <div className="modal-container">
      <div className="modal-container__body">
        {matchedItems.map((matchedItem) => {
          if (matchedItem.status === 'connected') {
            return (
              <div key={matchedItem.remoteIdentifier} className="modal-container__body__row">
                {t('products:shopify.maintain_sku_modal.no_longer_match')}
                <p>
                  {`"${matchedItem.name}"`} in {vendorName}.
                </p>
              </div>
            );
          }

          return (
            <div key={matchedItem.remoteIdentifier} className="modal-container__body__row">
              {t('products:shopify.maintain_sku_modal.does_match_new')}
              <p>
                {`"${matchedItem.name}"`} in {vendorName}.
              </p>
            </div>
          );
        })}
      </div>
    </div>
    <div className="modal-controls">
      {matchedItems.map((matchedItem) => {
        if (matchedItem.status === 'connected') {
          return (
            <div key={matchedItem.remoteIdentifier} className="modal-controls__row">
              <div>
                <header>{t('products:shopify.maintain_sku_modal.change_disconnect_header')}</header>
                <span display-if={skuChanged}>
                  {t('products:shopify.maintain_sku_modal.sku_change_disconnect_message')}
                </span>
                <span display-if={!skuChanged}>
                  {t('products:shopify.maintain_sku_modal.product_change_disconnect_message')}
                </span>
              </div>
              <button
                data-automation-id={`disconnect-${matchedItem.name}`}
                type="button"
                className="c-btn c-btn--medium"
                onClick={() => handleDisconnect()}
              >
                <span className="c-btn__text">{t('products:shopify.maintain_sku_modal.select_button')}</span>
              </button>
            </div>
          );
        }

        return (
          <div key={matchedItem.remoteIdentifier} className="modal-controls__row">
            <div>
              <header>{t('products:shopify.maintain_sku_modal.change_create_connection_header')}</header>
              <span display-if={skuChanged}>{t('products:shopify.maintain_sku_modal.sku_change_connect_message')}</span>
              <span display-if={!skuChanged}>
                {t('products:shopify.maintain_sku_modal.product_change_connect_message')}
              </span>
            </div>
            <button
              data-automation-id={`connect-${matchedItem.name}`}
              type="button"
              className="c-btn c-btn--medium"
              onClick={() => handleConnect(matchedItem.remoteIdentifier)}
            >
              <span className="c-btn__text">{t('products:shopify.maintain_sku_modal.select_button')}</span>
            </button>
          </div>
        );
      })}
    </div>
  </Modal>
);

MaintainSKUChangesModal.propTypes = {
  handleConnect: PropTypes.func.isRequired,
  handleDisconnect: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  matchedItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      remoteIdentifier: PropTypes.string.isRequired,
    })
  ).isRequired,
  openedIsOn: PropTypes.bool.isRequired,
  vendorName: PropTypes.string.isRequired,
  skuChanged: PropTypes.bool.isRequired,
};

export default MaintainSKUChangesModal;
